export enum RequisitionTabs {
    Active = 1,
    Completed = 2
}
